const btoaImplementation = (str: string) => {
    try {
        return btoa(str);
    } catch (err) {
        return Buffer.from(str).toString('base64');
    }
};

export default btoaImplementation;
